import {Component} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import {DataHandlerService} from '../../../services/data-handler.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import {
  CrumbSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/crumb-search/crumb-search.component';

@Component({
    selector: 'app-solicitor-borrower-details',
    templateUrl: './solicitor-borrower-details.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, MatCardModule, FormsModule, ReactiveFormsModule, CrumbSearchComponent]
})

export class SolicitorBorrowerDetailsComponent extends WizardWidgetComponent {

  constructor(public dataHandlerService: DataHandlerService) {
    super(dataHandlerService);
  }
}
